import { useRouter, useSearchParams } from 'next/navigation'
import { useCallback, useEffect } from 'react'
import { useChangeDashboardMutation } from '~/app/(dashboard)/dashboardQuery'

export function useSwitchWorkspaceFromQueryParams() {
  const searchParams = useSearchParams()
  const workspaceId = searchParams.get('workspace_id')
  const router = useRouter()
  const changeDashboard = useChangeDashboardMutation()

  const switchWorkspace = useCallback(async () => {
    if (workspaceId) {
      // Remove the workspace_id param
      const params = new URLSearchParams(window.location.search)
      params.delete('workspace_id')
      router.replace(
        `${window.location.pathname}${
          params.toString() ? '?' + params.toString() : ''
        }`
      )
      try {
        await changeDashboard.mutateAsync(workspaceId)
      } catch (error) {
        console.error(error)
      }
    }
  }, [workspaceId, changeDashboard, router])

  useEffect(() => {
    switchWorkspace()
  }, [switchWorkspace])
}
